import React, {useContext} from "react";
import {Button} from "@material-ui/core";
import {SelectionCriteriaContext} from "./SelectionCriteriaContext";

const PopoverActions = ({cancel, apply, applyButtonLabel}) => {
    const {currentFilterFront, listName} = useContext(SelectionCriteriaContext);
    let currentFilter = currentFilterFront;
    currentFilterFront.forEach(element => {
        if (element.field) {
            if (element.field.value === '') {
                return currentFilter = false
            } else if (element.operand.value === '') {
                return currentFilter = true
            } else {
                return currentFilter = false
            }
        }
        return false
    });

    return (
        <div style={{display: 'flex', justifyContent: 'flex-end'}}>
            <div style={{display: 'flex', gap: '10px', alignItems: 'center', justifyContent: 'end'}}>
                <Button
                    id={`${listName}_applyFilterBtn`}
                    size={"small"}
                    disabled={currentFilter}
                    variant="contained"
                    color="primary"
                    style={{width: "120px"}}
                    // type={'submit'}
                    // form={`advancedFilterForm_${listName}`}
                    onClick={apply}
                >
                    {applyButtonLabel || "Apply"}
                </Button>
                {!applyButtonLabel && (
                    <Button
                        variant="outlined"
                        color="default"
                        onClick={cancel}
                        style={{width: "120px"}}
                        size={"small"}
                    >
                        Cancel
                    </Button>
                )}
            </div>
        </div>
    )
};
export default PopoverActions